"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChimeDeviceObserver = void 0;
const streem_logger_1 = require("../util/streem_logger");
const permission_state_1 = require("../util/permission_state");
const rxjs_1 = require("rxjs");
class ChimeDeviceObserver {
    constructor(onLocalDevicesChanged, initialAudioInputDevices, initialAudioOutputDevices, initialVideoInputDevices) {
        this.logger = streem_logger_1.streemLogger.extend('sdk-chime-video:ChimeDeviceObserver');
        this.getUserMediaVideoErrorSubject = new rxjs_1.BehaviorSubject(undefined);
        this.getUserMediaVideoError = this.getUserMediaVideoErrorSubject.asObservable();
        this.getUserMediaAudioErrorSubject = new rxjs_1.BehaviorSubject(undefined);
        this.getUserMediaAudioError = this.getUserMediaAudioErrorSubject.asObservable();
        this.onLocalDevicesChanged = onLocalDevicesChanged;
        this.audioInputs = initialAudioInputDevices;
        this.audioOutputs = initialAudioOutputDevices;
        this.videoInputs = initialVideoInputDevices;
        this.onLocalDevicesChanged(this.getLocalDevices());
    }
    get audioOutputDevices() {
        return this.audioOutputs;
    }
    get audioInputDevices() {
        return this.audioInputs;
    }
    get videoInputDevices() {
        return this.videoInputs;
    }
    getLocalDevices() {
        return [...this.audioInputs, ...this.audioOutputs, ...this.videoInputs];
    }
    audioInputsChanged(freshAudioInputDevices) {
        this.audioInputs = freshAudioInputDevices;
        this.onLocalDevicesChanged(this.getLocalDevices());
    }
    audioOutputsChanged(freshAudioOutputDevices) {
        this.audioOutputs = freshAudioOutputDevices;
        this.onLocalDevicesChanged(this.getLocalDevices());
    }
    videoInputsChanged(freshVideoInputDevices) {
        this.videoInputs = freshVideoInputDevices;
        this.onLocalDevicesChanged(this.getLocalDevices());
    }
    videoInputStreamEnded(deviceId) {
        return __awaiter(this, void 0, void 0, function* () {
            this.logger.info(`Video input stream ended for device: ${deviceId}`);
            const permissionState = yield (0, permission_state_1.getPermissionsState)();
            if (permissionState.camera === 'denied') {
                this.logger.warn(`Camera permission state: ${permissionState.camera}`);
                this.getUserMediaVideoErrorSubject.next('NotAllowedError');
            }
        });
    }
    audioInputStreamEnded(deviceId) {
        return __awaiter(this, void 0, void 0, function* () {
            this.logger.info(`Audio input stream ended for device: ${deviceId}`);
            const permissionState = yield (0, permission_state_1.getPermissionsState)();
            if (permissionState.microphone === 'denied') {
                this.logger.warn(`Microphone permission state: ${permissionState.microphone}`);
                this.getUserMediaAudioErrorSubject.next('NotAllowedError');
            }
        });
    }
}
exports.ChimeDeviceObserver = ChimeDeviceObserver;
//# sourceMappingURL=chime_device_observer.js.map